module.exports = __webpack_public_path__ + "img/illu_token_03.0ed716de.svg";